<template>
  <span>
    <template v-for="(icon, i) in icons">
      <IconWithTooltip
        :key="`${icon.icon}-${i}`"
        v-bind="icon"
        :right="right"
        :tooltip-analytics-name="tooltipAnalyticsName"
      >
        {{ icon.message }}
        <component
          :is="icon.component"
          v-bind="icon.data"
          v-if="icon.component"
        />
      </IconWithTooltip>
    </template>
  </span>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import SpecialInstructionListItems from '@/components/SpecialInstructionListItems.vue'

import IconWithTooltip from './IconWithTooltip.vue'

export interface Icon {
  icon: string
  color?: string
  tooltipColor?: string
  message: string
  label?: string | number
  component?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: { [key: string]: any }
}

export default defineComponent({
  components: {
    IconWithTooltip,
    // Dynamic component
    SpecialInstructionListItems
  },
  props: {
    icons: {
      type: Array as PropType<Icon[]>,
      required: true
    },
    right: {
      type: Boolean,
      default: false
    },
    tooltipAnalyticsName: {
      type: String as PropType<string | undefined>,
      default: undefined
    }
  }
})
</script>
